import React, { Component } from "react";
import Card from "../../components/Card";
import Action from "../../components/Action";
import RadioQuestion from "../../components/RadioQuestion";
import ScrollToTop from "../../components/utils/ScrollToTop";
import Image from "../../components/Image";
import imageOfficeWorking from "../../images/office-working.png";

class ReferrerQuoteTransactionType extends Component {
  constructor(props) {
    super(props);

    if (this.props.selectedTransactionType) {
      this.state = {
        selectedTransactionType: this.props.selectedTransactionType,
        sellingDetails: null,
        errors: {},
      };
    } else {
      this.state = {
        selectedTransactionType: null,
        errors: {},
      };
    }
  }

  selectTransactionType = (t) => {
    this.setState({ selectedTransactionType: t });
  };

  handleValidation = () => {
    const fields = { ...this.state };
    let errors = {};
    let formIsValid = true;

    if (fields["selectedTransactionType"] == null) {
      errors["selectedTransactionType"] = true;
      formIsValid = false;
    }

    this.setState({ errors });
    return formIsValid;
  };

  handleFieldValidation = (field) => (event) => {
    const isBlur = event.type === "blur";
    this.setState((prevState) => {
      let errors = { ...prevState.errors };

      if (!isBlur) {
        errors[field] = false;
      } else {
        if (!prevState[field]) {
          errors[field] = true;
        }
      }
      return { errors };
    });
  };

  saveSelection = () => {
    if (this.handleValidation()) {
      this.props.onStepComplete({
        transactionType: this.state.selectedTransactionType,
        sellingDetails: this.state.sellingDetails,
      });
    }
  };

  render() {
    return (
      <React.Fragment>
        <ScrollToTop />

        <Card title="Refer a client to Juno" removeTopPadding>
          <p>
            You’ll see the price first. Then we email it to your client and call them to talk it through. The referral
            is credited to you.
          </p>

          <RadioQuestion
            question="Is your client buying, selling, or both?"
            options={this.props.transactionTypeOptions}
            name="quoteType"
            selected={this.state.selectedTransactionType}
            optionSelected={this.selectTransactionType}
            validate={this.handleFieldValidation("selectedTransactionType")}
            validationError={this.state.errors["selectedTransactionType"] ? "Choose buying, selling or both" : null}
          />

          <Action onClick={this.saveSelection}>Continue</Action>
        </Card>

        <Image src={imageOfficeWorking} fullWidth />
      </React.Fragment>
    );
  }
}

export default ReferrerQuoteTransactionType;
